module.exports = __webpack_public_path__ + "static/media/reorder.30f63ee3.jpg";